import React from "react";

export class CookiePolicyES extends React.Component {
    render() {
        return (
            <>
                <p>
                    Última actualización: <b>18/06/2026</b>
                    <br />
                    <br />
                </p>
                <p>
                    Este documento se ha elaborado de conformidad con el Reglamento de la UE 2016/679 (el "GDPR") para que los usuarios puedan comprender qué cookies se instalan
                    cuando utilizan un portal de DeepUnity PACSonWEB (el "Sitio Web").
                </p>
                <h2>1. Responsable del tratamiento y delegado de protección de datos</h2>
                <p>
                    DH Healthcare GmbH, con domicilio social en Konrad-Zuse-Platz 1-3, 53227 Bonn, Germany, es el controlador de datos de los datos personales (los Datos) de los
                    usuarios del sitio web recopilados mediante cookies. Para cualquier solicitud es posible escribir a DH Healthcare GmbH a la dirección física mencionada
                    anteriormente o a través de la dirección de correo electrónico.
                    <br />
                    <br />
                    DH Healthcare GmbH ha designado un Delegado de Protección de Datos ("DPO"), con el que se puede contactar en Dpo.belgium@dedalus.eu
                </p>
                <h2>2. Datos tratados por DH Healthcare GmbH</h2>
                <p>
                    Lapublicación en la webimplica el uso de cookies, cadenas cortas de texto que los sitios web visitados envían al navegador del usuario, donde se almacenan y
                    luego se transmiten a los mismos sitios web durante las visitas posteriores. Mientras navega por un sitio, el usuario también puede recibir cookies en
                    sucomputadora de sitios o servidores web distintos del que está visitando (las llamadas cookies de "terceros"). Es posible distinguir:
                    <br />
                    <br />
                    a. Cookies técnicas, que permiten llevar a cabo actividades relacionadas con el funcionamiento del Sitio.
                    <br />
                    <br />
                    b. Cookies de elaboración de perfiles, utilizadas para analizar el comportamiento del usuario y, si es necesario, para enviar mensajes publicitarios en línea
                    con las preferencias expresadas por el usuario durante la navegación.
                    <br />
                    <br />
                    c. Almacenamiento local, que permiten llevar a cabo actividades relacionadas con el funcionamiento del Sitio.
                </p>
                <p>
                    <br />
                    Este sitio web utiliza las siguientes cookies:
                </p>
                <h3>a) Cookies técnicas</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Anfitrión</th>
                            <th>Categoría</th>
                            <th>Descripción</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>__Hosts-FormsAuthentication</td>
                            <td>Dobco</td>
                            <td>Necesario</td>
                            <td>Autenticación del portal DeepUnity PACSonWEB</td>
                        </tr>
                        <tr>
                            <td>__Hosts-Session</td>
                            <td>Dobco</td>
                            <td>Necesario</td>
                            <td>ID de sesión del portal DeepUnity PACSonWEB</td>
                        </tr>
                        <tr>
                            <td>Language</td>
                            <td>Dobco</td>
                            <td>Necesario</td>
                            <td>Registra la elección de idioma en cuanto se cambia manualmente (el idioma del navegador se utiliza como estándar)</td>
                        </tr>
                        <tr>
                            <td>Source</td>
                            <td>Dobco</td>
                            <td>Necesario</td>
                            <td>Portal de clientes en el que se ha registrado.</td>
                        </tr>
                        <tr>
                            <td>HidePatientLogin</td>
                            <td>Dobco</td>
                            <td>Necesario</td>
                            <td>Oculta el inicio de sesión de paciente en la página de acceso.</td>
                        </tr>
                        <tr>
                            <td>LocalImageCaches</td>
                            <td>Dobco</td>
                            <td>Necesario</td>
                            <td>Registra las cachés de imágenes locales, vinculadas al usuario.</td>
                        </tr>
                        <tr>
                            <td>LastUserName</td>
                            <td>Dobco</td>
                            <td>Necesario</td>
                            <td>
                                Registra el último nombre de usuario utilizado para iniciar sesión en el sistema. Se utiliza para rellenar previamente el campo de nombre de usuario
                                en el siguiente inicio de sesión.
                            </td>
                        </tr>
                        <tr>
                            <td>UrlReferrer</td>
                            <td>Dobco</td>
                            <td>Necesario</td>
                            <td>
                                Registra la URL de la página desde la que llegó al sistema. Se utiliza para redirigirle de nuevo a esa página después del inicio de sesión, si no
                                venía de la página de inicio de sesión.
                            </td>
                        </tr>
                        <tr>
                            <td>Dobco.AcceptedAllCookies </td>
                            <td>Dobco</td>
                            <td>Funcional</td>
                            <td>Esta cookie se establece si elige permitir todas las cookies y registra cuándo se configuró.</td>
                        </tr>
                        <tr>
                            <td>Dobco.AcceptedNecessaryCookies</td>
                            <td>Dobco</td>
                            <td>Necesario</td>
                            <td>Esta cookie se establece si elige permitir solo las cookies necesarias y registra cuándo se configuró.</td>
                        </tr>
                        <tr>
                            <td>__Secure-UI-External-Login</td>
                            <td>Dobco</td>
                            <td>Necesario</td>
                            <td>
                                Guarda el estado durante un ciclo de inicio de sesión externo (cuando inicia sesión a través de un proveedor de identidad externo como ADFS). Es
                                necesario por razones de seguridad para prevenir ataques CSRF y de repetición.
                            </td>
                        </tr>
                        <tr>
                            <td>__Secure-UI-OIDC-Session</td>
                            <td>Dobco</td>
                            <td>Necesario</td>
                            <td>Le mantiene conectado al proveedor de inicio de sesión de DeepUnity PACSonWEB tras un inicio de sesión correcto.</td>
                        </tr>
                        <tr>
                            <td>__Secure-UI-Pending-Auth</td>
                            <td>Dobco</td>
                            <td>Necesario</td>
                            <td>
                                Almacena temporalmente la solicitud de inicio de sesión pendiente mientras se le redirige a la página de inicio de sesión. Es necesario para
                                completar el inicio de sesión.
                            </td>
                        </tr>
                        <tr>
                            <td>__Secure-UI-Pending-2FA</td>
                            <td>Dobco</td>
                            <td>Necesario</td>
                            <td>
                                Transporta temporalmente el estado de la autenticación de dos factores entre el paso de inicio de sesión y el paso de verificación. Es necesario
                                para completar la autenticación de dos factores.
                            </td>
                        </tr>
                        <tr>
                            <td>__Secure-UI-2FA-Skip</td>
                            <td>Dobco</td>
                            <td>Necesario</td>
                            <td>
                                Recuerda que ha completado la autenticación de dos factores para que no se le pida de nuevo un segundo factor en el mismo navegador durante un
                                período limitado.
                            </td>
                        </tr>
                        <tr>
                            <td>__Secure-UI-Authentication</td>
                            <td>Dobco</td>
                            <td>Necesario</td>
                            <td>Autenticación del portal DeepUnity PACSonWEB para el proveedor de inicio de sesión.</td>
                        </tr>
                        <tr>
                            <td>__Secure-UI-Antiforgery</td>
                            <td>Dobco</td>
                            <td>Necesario</td>
                            <td>Protege los formularios de inicio de sesión contra ataques de falsificación de solicitudes entre sitios (CSRF).</td>
                        </tr>
                        <tr>
                            <td>__Secure-UI-BankId</td>
                            <td>Dobco</td>
                            <td>Necesario</td>
                            <td>
                                Guarda el estado durante un inicio de sesión con BankID (cuando un paciente inicia sesión con BankID). Esto es necesario por motivos de seguridad
                                para prevenir ataques CSRF y de repetición.
                            </td>
                        </tr>
                        <tr>
                            <td>__Secure-UI-Post-Logout-Parameters</td>
                            <td>Dobco</td>
                            <td>Necesario</td>
                            <td>Recuerda cómo inició sesión para que también pueda cerrar sesión en ese proveedor de identidad (BankID o eID / itsme) cuando cierre sesión.</td>
                        </tr>
                        <tr>
                            <td>__Secure-UI-Pending-eID</td>
                            <td>Dobco</td>
                            <td>Necesario</td>
                            <td>
                                Guarda el estado durante un proceso de inicio de sesión con eID / itsme (cuando un profesional sanitario inicia sesión con eID o itsme). Esto es
                                necesario por motivos de seguridad para evitar ataques CSRF y de repetición.
                            </td>
                        </tr>
                        <tr>
                            <td>__Secure-Last-Login</td>
                            <td>Dobco</td>
                            <td>Necesario</td>
                            <td>
                                Recuerda cómo inició sesión por última vez, de modo que la experiencia de inicio de sesión pueda adaptarse en las aplicaciones vinculadas de
                                DeepUnity PACSonWEB.
                            </td>
                        </tr>
                    </tbody>
                </table>
                <h3>b) Cookies analíticas/de elaboración de perfiles</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Anfitrión</th>
                            <th>Duración</th>
                            <th>Categoría</th>
                            <th>Descripción</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>_GA</td>
                            <td>Google</td>
                            <td>2 años</td>
                            <td>Analítico</td>
                            <td>Se utiliza para distinguir a los usuarios.</td>
                        </tr>
                        <tr>
                            <td>_GID</td>
                            <td>Google</td>
                            <td>24 horas</td>
                            <td>Analítico</td>
                            <td>Se utiliza para distinguir a los usuarios.</td>
                        </tr>
                        <tr>
                            <td>_GA_&lt;container_id&gt;</td>
                            <td>Google</td>
                            <td>2 años</td>
                            <td>Analítico</td>
                            <td>Se utiliza para conservar el estado de sesión.</td>
                        </tr>
                    </tbody>
                </table>
                <h3>c) Almacenamiento local (Host: Dobco; Categoría : Necesario)</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Descripción</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>shownNews</td>
                            <td>La última ocasión en que abrió los anuncios.</td>
                        </tr>
                        <tr>
                            <td>POWHomerBGuid</td>
                            <td>ID para el uso de HomeReading.</td>
                        </tr>
                        <tr>
                            <td>POW3SharingPrintSettings</td>
                            <td>Configuraciones preferidas para imprimir un número de referencia.</td>
                        </tr>
                        <tr>
                            <td>POW3SharingAnonDestinationSettings</td>
                            <td>Configuraciones preferidas para compartir un estudio con destinos anónimos.</td>
                        </tr>
                        <tr>
                            <td>POW3SharingOtherDestinationSettings</td>
                            <td>Configuraciones preferidas para compartir un estudio con otros destinos.</td>
                        </tr>
                        <tr>
                            <td>printing_check_openByDefault</td>
                            <td>Configuración preferida para imprimir un estudio.</td>
                        </tr>
                        <tr>
                            <td>acceptedPOW3Cookies</td>
                            <td>Registra si la política de cookies ya se ha mostrado en el proyecto de registro de usuarios.</td>
                        </tr>
                        <tr>
                            <td>POW3LoginOption</td>
                            <td>Cómo se ha conectado (paciente / médico).</td>
                        </tr>
                        <tr>
                            <td>uniqueBrowserIdentifier</td>
                            <td>
                                Identifica de forma exclusiva su navegador dentro de DeepUnity PACSonWEB. Se utiliza para determinar si se le pide que introduzca una OTP durante el
                                inicio de sesión o no.
                            </td>
                        </tr>
                        <tr>
                            <td>LastAudioOutVolume</td>
                            <td>Guarda el último nivel de salida de volumen de audio utilizado.</td>
                        </tr>
                        <tr>
                            <td>PreferredRecognitionLanguage</td>
                            <td>Guarda el idioma de reconocimiento de voz que prefieras.</td>
                        </tr>
                        <tr>
                            <td>scalingFactorConfiguration</td>
                            <td>Guarda su factor de escala preferido y la resolución inicial correspondiente.</td>
                        </tr>
                        <tr>
                            <td>dontShowPopupForNewsIds</td>
                            <td>Identifica las ventanas emergentes de noticias que no quieres volver a ver.</td>
                        </tr>
                        <tr>
                            <td>DefaultFontSize</td>
                            <td>Guarda el tamaño de letra que prefiere en el informe.</td>
                        </tr>
                        <tr>
                            <td>SeriesPickerPosition</td>
                            <td>Guarda la posición que prefiere del selector de series.</td>
                        </tr>
                        <tr>
                            <td>SeriesPickerWidth</td>
                            <td>Guarda el ancho que prefiere del selector de series.</td>
                        </tr>
                        <tr>
                            <td>lastUsedInputDevice</td>
                            <td>Guarda el último dispositivo de entrada utilizado al dictar.</td>
                        </tr>
                        <tr>
                            <td>lastUsedOutputDevice</td>
                            <td>Guarda el último dispositivo de salida utilizado al dictar.</td>
                        </tr>
                        <tr>
                            <td>AgreedToUserConditions</td>
                            <td>Guarda que aceptó las condiciones de uso.</td>
                        </tr>
                        <tr>
                            <td>POW3PreferredEnvironmentUID / preferredEnvironmentUid</td>
                            <td>Guarda el entorno que prefiere cuando se le solicita.</td>
                        </tr>
                        <tr>
                            <td>closedBrowserSupport</td>
                            <td>Guarda que cerró el diálogo de compatibilidad del navegador.</td>
                        </tr>
                        <tr>
                            <td>activeLoginTab</td>
                            <td>Guarda qué pestaña de inicio de sesión tenía seleccionada.</td>
                        </tr>
                        <tr>
                            <td>FailedLoginVerification</td>
                            <td>Registra, para la sesión actual del navegador, que ya se le ha mostrado la notificación sobre los intentos fallidos de inicio de sesión.</td>
                        </tr>
                    </tbody>
                </table>
                <p>
                    Si bien las cookies técnicas necesarias no pueden ser rechazadas por el usuario del sitio web, ya que son estrictamente funcionales para el sitio web en sí, el
                    usuario puede elegir libremente aceptar o rechazar el uso de análisis, perfiles y cookies no estrictamente necesarias. El usuario puede configurar y revisar sus
                    opciones con respecto a las cookies con la función "Cambiar la configuración de las cookies" disponible en el sitio web (Sección "Jurídico”).
                </p>
                <h2>3. Finalidades y base jurídicadel tratamiento</h2>
                <p>
                    Mediante lascookies se persiguen las siguientes finalidades:
                    <br />
                    <br /> 3.1. Para permitir la navegación de la weby su funcionalidad fluida. La base legal para el tratamiento es la prestación a los usuarios de servicios
                    relacionados con la Webite y el interés legítimo de Dedalus de disponer de un sitio web funcional.
                    <br />
                    <br /> 3.2. Para cumplir con cualquier obligación en virtud de las leyes, reglamentos o legislación de la UE aplicables, o para cumplir con las solicitudes de
                    las autoridades. La base legal para el procesamiento es la obligación de Dedalus de cumplir con la legislación obligatoria.
                    <br />
                    <br /> 3.3. Analizar el comportamiento del usuario y, en su caso, enviarle mensajes publicitarios de acuerdo con las preferencias expresadas por el mismo
                    durante la navegación. La base legal para el tratamiento en este caso es el consentimiento del interesado.
                    <br />
                    <br /> 3.4. Para las necesidades de defensa de los derechos de Dedalus en el contexto de cualquier litigio, incluso en los tribunales. La base legal del
                    procesamiento es el interés legítimo del Propietario para proteger sus derechos.
                    <br />
                    <br /> La concesión de Datos es opcional, pero (excepto en casos de procesamiento basado en el consentimiento) la falta de suministro de Datos impide que el
                    Controlpermita la navegación del sitio web.
                </p>
                <h2>4. Destinatarios de los datos</h2>
                <p>
                    Los Datos podrán ser comunicados:
                    <br />
                    <br />
                    (a) a terceros que necesiten realizar actividades específicas en relación con los Datos, de acuerdo con los fines del procesamiento, o a proveedores de
                    servicios al Controlador de datos.
                    <br />
                    <br />
                    (b) a las autoridades, entidades y/o partes a las que deben divulgarse los Datos, de conformidad con disposiciones legales o contractuales vinculantes.
                    <br />
                    <br />
                    (c) en otras circunstancias, como adquisiciones y ventas a posibles empresas de terceros, cuando esperamos vender o transferir parte o la totalidad de nuestro
                    negocio.
                </p>
                <h2>5. Transferencia de datos fueradel Espacio Económico Europeo</h2>
                <p>
                    En cuanto a la posible transferencia de Datos a países no pertenecientes al Espacio Económico Europeo, el procesamiento se llevará a cabo de acuerdo con uno de
                    los métodos legalmente permitidos y, por lo tanto, a través de la selección de destinatarios establecidos en países considerados adecuados por la Comisión
                    Europea o mediante la estipulación de cláusulas contractuales estándar.
                </p>
                <h2>6. Retención de datos</h2>
                <p>
                    Los Datos se conservarán únicamente durante el tiempo necesario para los fines para los que fueron recogidos, respetando los principios de limitación y
                    minimización de la conservación. Más precisamente, los términos de duración de las cookies se definen en la sección 2 anterior. Para los Datos cuyo tratamiento
                    se base en el consentimiento del interesado, se especifica que los mismos se conservarán hasta que se revoque dicho consentimiento.
                </p>
                <h2>7. Derechos de los interesados</h2>
                <p>
                    En presencia de los requisitos legales pertinentes, el interesado puede solicitar al Controlador de datos o al DPO el acceso a sus Datos, rectificarlos o
                    eliminarlos u oponerse a su procesamiento, solicitar la restricción del procesamiento en los casos previstos por el Artículo 18 GDPR, así como obtener de manera
                    estructurada, formato de uso común y legible por máquina de los datos que le conciernen, en los casos previstos en el artículo 20 del RGPD.
                    <br />
                    <br />
                    Además, el usuario tiene derecho a revocar cualquier consentimiento para el procesamiento en cualquier momento, sin afectar la legalidad del procesamiento
                    realizado por el Controlador antes de la revocación.
                    <br />
                    Las solicitudes deben hacerse por escrito al Controlador de datos a las direcciones indicadas anteriormente.
                    <br />
                    <br />
                    En cualquier caso, el interesado podrá presentar una reclamación ante el Garante de Protección de Datos Personales si considera que el tratamiento de sus Datos
                    es contrario a la normativa vigente.
                </p>
            </>
        );
    }
}
